import moment from 'moment';
import {DATE_FORMAT} from "../../constants";

export const valueByInputTypeTransformer = (type, value, checked) => {
    switch (type) {
        case 'checkbox':
            return checked;
        case 'date':
            return moment(value).format(DATE_FORMAT);
        case 'number':
            if ('' === value) {
                return null;
            }
            return Number(value);
        default:
            return value === '' ? null : value;
    }
}
